import { Card, Space, Button, Flex, Row, Col, Input } from 'antd';
import { EditOutlined } from "@ant-design/icons";
import InputNumber from "components/input-number";
import { formatCurrency } from "utils/number";
import { useOrderEditContext } from '../OrderEditContext';

const OrderSummaryCardDesktop = () => {
    const {
        data,
        form,
        navigate,
        showEditF,
        showEdit,
        onDiscountAmountChange,
        onShippingAmountChange,
        onLoyaltyPointChange,
        onVoucherCodeChange,
    } = useOrderEditContext();

    return (
        <Card>
            <table style={{ width: "100%" }} className='tbl_order'>
                <colgroup>
                    <col></col>
                    <col style={{ textAlign: "right" }}></col>
                </colgroup>
                <tbody className='ant-table-tbody'>
                    <tr>
                        <td>Tiền hàng</td>
                        <td style={{ textAlign: "right" }}>
                            {formatCurrency(data.sub_amount)}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Space>
                                Giảm giá
                                <Button onClick={() => showEdit("discount")} type='text'><EditOutlined /></Button>
                            </Space>
                        </td>
                        <td style={{ textAlign: "right" }}>
                            {!showEditF.discount ? (
                                <>{formatCurrency(data.discount_amount)}</>
                            ) : (
                                <Flex justify='flex-end'>
                                    <InputNumber value={data.discount_amount} onChange={onDiscountAmountChange} showCalculator={false} />
                                </Flex>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Space>
                                Mã khuyến mãi
                                <Button onClick={() => showEdit("voucher")} type='text'><EditOutlined /></Button>
                            </Space>
                        </td>
                        <td style={{ textAlign: "right" }}>
                            <Row>
                                <Col span={12}>
                                    {!showEditF.voucher ? (
                                        <>{data.voucher_code}</>
                                    ) : (
                                        <Input value={data.voucher_code} onChange={onVoucherCodeChange} />
                                    )}
                                </Col>
                                <Col span={12}>
                                    <Flex justify='flex-end' align='center' style={{ height: "100%" }}>
                                        {formatCurrency(data.voucher_amount)}
                                    </Flex>
                                </Col>
                            </Row>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Space>
                                Xu
                                <Button onClick={() => showEdit("point")} type='text'><EditOutlined /></Button>
                            </Space>
                        </td>
                        <td style={{ textAlign: "right" }}>
                            {!showEditF.point ? (
                                <>{formatCurrency(data.loyalty_point)}</>
                            ) : (
                                <Flex justify='flex-end'>
                                    <InputNumber value={data.loyalty_point} onChange={onLoyaltyPointChange} showCalculator={false} />
                                </Flex>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Space>
                                Phí ship
                                <Button onClick={() => showEdit("shiping")} type='text'><EditOutlined /></Button>
                            </Space>
                        </td>
                        <td style={{ textAlign: "right" }}>
                            {!showEditF.shiping ? (
                                <>{formatCurrency(data.shipping_amount)}</>
                            ) : (
                                <Flex justify='flex-end'>
                                    <InputNumber value={data.shipping_amount} onChange={onShippingAmountChange} showCalculator={false} />
                                </Flex>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>Tổng tiền</td>
                        <td style={{ textAlign: "right" }}>
                            {formatCurrency(data.total_amount)}
                        </td>
                    </tr>
                </tbody>
            </table>
            <Flex justify='flex-end' style={{ marginTop: 16 }}>
                <Space align='end'>
                    {data.id && (
                        <Button onClick={() => navigate(`/order/${data.id}`)}>Trở về</Button>
                    )}
                    <Button type='primary' onClick={() => form.submit()}>Lưu</Button>
                </Space>
            </Flex>
        </Card>
    );
};

export default OrderSummaryCardDesktop;
